import React, { useState } from 'react';
import { AdvancedMarker, Pin } from '@vis.gl/react-google-maps';
import { useSelector, useDispatch } from 'react-redux';

export const SelectedMarker = (props) => {
    const userCategories = useSelector(state=>state.viewingUserCategories);
    const selectedEvent = useSelector(state=>state.selectedEvent);
    const event = props.event;

    if(!selectedEvent)
      return null;

    return (
      <AdvancedMarker
        position={selectedEvent.location.coordinates}
        key={selectedEvent.id + 'selected'}
        zIndex={99}
        onClick={props.onClick ? () => props.onClick(selectedEvent) : undefined}
      >
        <Pin background={userCategories[selectedEvent.categoryId].pinColor} borderColor={userCategories[selectedEvent.categoryId].pinColor} scale={1.3}>
          <p style={{fontSize:'22px'}}>{selectedEvent.emoji}</p>
        </Pin>
      </AdvancedMarker>
      );
  };